import { useI18n } from "@wojo/localization";
import React, { useCallback } from "react";
import {
    useTripBuilderPublishDraftQuoteMutation,
    useTripBuilderSetDraftQuoteCustomerMutation,
} from "../../../../generated/graphql";
import { useDraftQuoteFragment } from "./use-draft-quote-fragment";

export const useHandleCustomerChange = (
    draftId: string | null | undefined,
    setError: React.Dispatch<React.SetStateAction<string>>,
) => {
    const { global } = useI18n("global");
    const [setDraftQuoteCustomer] =
        useTripBuilderSetDraftQuoteCustomerMutation();
    const [publishDraftQuote] = useTripBuilderPublishDraftQuoteMutation();

    const draftQuote = useDraftQuoteFragment(draftId);

    return useCallback(
        async (customerId?: string | null, callback = () => {}) => {
            setError("");
            if (draftQuote && customerId) {
                await setDraftQuoteCustomer({
                    variables: {
                        id: draftQuote._id,
                        tripId: draftQuote.order.trips[0]._id,
                        existingCustomerInput: {
                            customerId,
                        },
                    },
                    onCompleted: async (data) => {
                        if (
                            data.setDraftQuoteCustomer.__typename ===
                            "DraftOrder"
                        ) {
                            await publishDraftQuote({
                                variables: {
                                    id: draftQuote._id,
                                },

                                onError: () => {
                                    setError(global.errors.generic.l());
                                },
                            });
                            callback();
                        } else {
                            setError(global.errors.generic.l());
                        }
                    },
                    onError: () => {
                        setError(global.errors.generic.l());
                    },
                });
            } else {
                setError(global.errors.generic.l());
            }
        },
        [
            draftQuote,
            global.errors.generic,
            publishDraftQuote,
            setDraftQuoteCustomer,
            setError,
        ],
    );
};
